import { render } from "./verifty.vue?vue&type=template&id=0ffff9b8&scoped=true"
import script from "./verifty.vue?vue&type=script&lang=js"
export * from "./verifty.vue?vue&type=script&lang=js"

import "./verifty.vue?vue&type=style&index=0&id=0ffff9b8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ffff9b8"]])

export default __exports__